<template>
  <div class="chat-message-item">
    <div v-if="message.reply_to" class="reply-preview">
      <strong>@{{ message.reply_to.user.username }}</strong>
      <span>{{ truncate(message.reply_to.body) }}</span>
    </div>
    <div class="message-row">
      <span class="author">{{ message.user.username }}</span>
      <span class="time">{{ formatTime(message.created_at) }}</span>
      <div class="message-actions">
        <button
          v-if="showPrivateButton && message.user.id !== currentUserId"
          type="button"
          class="button is-small is-link is-light"
          v-on:click="$emit('private-chat', message.user)"
        >
          Приват
        </button>
        <button type="button" class="button is-small is-link is-light" v-on:click="$emit('reply', message)">
          Ответить
        </button>
      </div>
    </div>
    <p class="body">{{ message.body }}</p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
    currentUserId: {
      type: String,
      default: null,
    },
    showPrivateButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatTime (value) {
      if (!value) return ''
      const date = new Date(value)
      return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
    },
    truncate (text) {
      if (!text) return ''
      return text.length > 80 ? `${text.slice(0, 80)}…` : text
    },
  },
}
</script>

<style scoped>
.chat-message-item {
  padding: 0.35rem 0.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.reply-preview {
  font-size: 0.75rem;
  color: #7a7a7a;
  border-left: 3px solid #dbdbdb;
  padding-left: 0.5rem;
  margin-bottom: 0.25rem;
}

.message-row {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.author {
  font-weight: 600;
  font-size: 0.85rem;
}

.time {
  font-size: 0.7rem;
  color: #999;
}

.message-actions {
  margin-left: auto;
  display: flex;
  gap: 0.5rem;
}

.body {
  margin: 0.15rem 0 0;
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
